import { useLocalization as e } from "./localization/index.js";
import { getSchemaType as t } from "./helpers/get-schema-type.js";
import { getModelNameWithArray as n } from "./helpers/schema-name.js";
import { getDisplayTypeSignatureTokens as r } from "./helpers/get-type-signature-tokens.js";
import i from "../shared/Badge.vue.js";
import { isModelLinkable as a } from "./helpers/is-model-linkable.js";
import o from "./RenderString.vue.js";
import ee from "./SchemaPropertyDefault.vue.js";
import s from "./SchemaPropertyDetail.vue.js";
import c from "./SchemaPropertyExamples.vue.js";
import te from "./SchemaPropertyPattern.vue.js";
import { Fragment as l, computed as u, createBlock as d, createCommentVNode as f, createElementBlock as p, createElementVNode as m, createSlots as ne, createTextVNode as h, createVNode as g, defineComponent as _, normalizeClass as v, openBlock as y, renderList as b, renderSlot as x, toDisplayString as S, toRef as re, unref as C, withCtx as w } from "vue";
import { isDefined as T } from "@scalar/helpers/array/is-defined";
import { resolve as E } from "@scalar/workspace-store/resolve";
import { isArraySchema as D, isNumberSchema as O, isStringSchema as k } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/SchemaPropertyHeading.vue?vue&type=script&setup=true&lang.ts
var A = { class: "property-heading [&>.property-detail:has(+.property-detail)]:mr-0" }, j = {
	key: 1,
	class: "property-discriminator"
}, M = { class: "font-code text-c-accent" }, N = { class: "screenreader-only" }, P = {
	key: 0,
	class: "property-type-signature text-c-2 text-(length:--scalar-mini)"
}, F = {
	key: 1,
	class: "property-type-signature text-c-2 text-(length:--scalar-mini)"
}, I = {
	key: 0,
	class: "screenreader-only"
}, L = {
	key: 3,
	class: "property-additional"
}, R = {
	key: 4,
	class: "property-deprecated"
}, z = {
	key: 5,
	class: "text-c-2"
}, B = {
	key: 6,
	class: "property-const"
}, V = {
	key: 8,
	class: "property-write-only"
}, H = {
	key: 9,
	class: "property-read-only"
}, U = {
	key: 10,
	class: "property-required"
}, W = /*@__PURE__*/ _({
	__name: "SchemaPropertyHeading",
	props: {
		value: {},
		enum: { type: Boolean },
		isDiscriminator: {
			type: Boolean,
			default: !1
		},
		discriminatorValue: {},
		required: {
			type: Boolean,
			default: !1
		},
		additional: { type: Boolean },
		withExamples: {
			type: Boolean,
			default: !0
		},
		hideModelNames: {
			type: Boolean,
			default: !1
		},
		modelLinkOptions: {},
		modelName: {},
		propertyNames: {},
		eventBus: { default: null },
		keyKind: {},
		recursiveTo: {}
	},
	setup(_) {
		let W = _, { translate: G } = e(), K = re(W, "value"), q = u(() => {
			if (!K.value) return;
			let e = K.value;
			if (e.const !== void 0) return e.const;
			if (e.enum?.length === 1) return e.enum[0];
			if (D(e) && e.items) {
				let t = E.schema(e.items);
				if (T(t.const)) return t.const;
				if (t.enum?.length === 1) return t.enum[0];
			}
		}), J = (e) => {
			let t = [];
			return k(e) && (e.minLength && t.push({
				key: "min-length",
				prefix: `${G("schema.minLength")}: `,
				value: e.minLength
			}), e.maxLength && t.push({
				key: "max-length",
				prefix: `${G("schema.maxLength")}: `,
				value: e.maxLength
			})), (k(e) || O(e)) && e.format && t.push({
				key: "format",
				value: e.format,
				truncate: !0
			}), O(e) && (T(e.exclusiveMinimum) && t.push({
				key: "exclusive-minimum",
				prefix: `${G("schema.greaterThan")}: `,
				value: e.exclusiveMinimum
			}), T(e.minimum) && t.push({
				key: "minimum",
				prefix: `${G("schema.min")}: `,
				value: e.minimum
			}), T(e.exclusiveMaximum) && t.push({
				key: "exclusive-maximum",
				prefix: `${G("schema.lessThan")}: `,
				value: e.exclusiveMaximum
			}), T(e.maximum) && t.push({
				key: "maximum",
				prefix: `${G("schema.max")}: `,
				value: e.maximum
			}), T(e.multipleOf) && t.push({
				key: "multiple-of",
				prefix: `${G("schema.multipleOf")}: `,
				value: e.multipleOf
			})), t;
		}, ie = u(() => {
			if (!K.value) return [];
			let e = K.value, t = [];
			return D(e) && ((e.minItems || e.maxItems) && t.push({
				key: "array-range",
				value: `${e.minItems || ""}…${e.maxItems || ""}`
			}), e.uniqueItems && t.push({
				key: "unique-items",
				value: `${G("schema.unique")}!`
			})), t.push(...J(e)), D(e) && e.items && t.push(...J(E.schema(e.items))), t;
		}), Y = u(() => !W.value || W.hideModelNames ? null : W.modelName ? {
			schemaKey: W.modelName,
			label: W.modelName
		} : n(W.value)), ae = u(() => a(Y.value?.schemaKey, W.modelLinkOptions ?? {})), X = u(() => r(W.value, {
			hideModelNames: W.hideModelNames,
			modelName: Y.value?.label
		})), oe = u(() => !W.value || !("type" in W.value) ? !1 : W.value.type === "array" || !q.value), Z = u(() => {
			let e = W.propertyNames;
			if (!e) return;
			let n = [t(e)];
			"format" in e && typeof e.format == "string" && n.push(e.format);
			let r = n.filter(Boolean).join(" · ");
			return r.length > 0 ? r : void 0;
		}), Q = u(() => {
			if (W.value && "example" in W.value && W.value.example !== void 0) return W.value.example;
			if (W.value && D(W.value)) {
				let e = E.schema(W.value.items);
				if (e && "example" in e && e.example !== void 0) return e.example;
			}
		}), se = u(() => {
			if (Q.value !== void 0) return !0;
			let e = W.value?.examples;
			return !!e && typeof e == "object" && Object.keys(e).length > 0;
		}), $ = u(() => {
			let e = K.value;
			if (e) {
				if (k(e) && e.pattern) return e.pattern;
				if (D(e) && e.items) {
					let t = E.schema(e.items);
					if (k(t) && t.pattern) return t.pattern;
				}
			}
		});
		return (e, t) => (y(), p("div", A, [
			e.$slots.name ? (y(), p("div", {
				key: 0,
				class: v(["property-name", { deprecated: W.value?.deprecated }])
			}, [x(e.$slots, "name", {}, void 0, !0)], 2)) : f("", !0),
			W.isDiscriminator ? (y(), p("div", j, S(C(G)("schema.discriminator")), 1)) : f("", !0),
			W.value ? (y(), p(l, { key: 2 }, [
				W.keyKind ? (y(), d(s, {
					key: 0,
					class: "property-key-kind"
				}, {
					default: w(() => [m("span", M, S(W.keyKind === "pattern" ? "patternProperty" : "additionalProperty"), 1)]),
					_: 1
				})) : f("", !0),
				oe.value ? (y(), d(s, {
					key: 1,
					truncate: ""
				}, {
					default: w(() => [m("span", N, S(C(G)("schema.type")) + ": ", 1), W.eventBus && Y.value?.schemaKey && ae.value ? (y(), p("button", {
						key: 0,
						class: "text-c-2 hover:text-c-1 underline",
						type: "button",
						onClick: t[0] ||= (e) => W.eventBus.emit("scroll-to:model-by-name", { name: Y.value.schemaKey })
					}, [X.value.length ? (y(), p("span", P, [(y(!0), p(l, null, b(X.value, (e, t) => (y(), p(l, { key: t }, [h(S(t > 0 ? " " : ""), 1), m("span", { class: v(["property-type-token", [
						`property-type-token--${e.kind}`,
						e.kind === "word" ? "font-sans" : "",
						e.kind === "ident" || e.kind === "literal" ? "font-code" : "",
						e.kind === "punctuation" ? "text-c-2" : ""
					]]) }, S(e.text), 3)], 64))), 128))])) : f("", !0)])) : X.value.length ? (y(), p("span", F, [(y(!0), p(l, null, b(X.value, (e, t) => (y(), p(l, { key: t }, [h(S(t > 0 ? " " : ""), 1), m("span", { class: v(["property-type-token", [
						`property-type-token--${e.kind}`,
						e.kind === "word" ? "font-sans" : "",
						e.kind === "ident" || e.kind === "literal" ? "font-code" : "",
						e.kind === "punctuation" ? "text-c-2" : ""
					]]) }, S(e.text), 3)], 64))), 128))])) : f("", !0)]),
					_: 1
				})) : f("", !0),
				W.recursiveTo ? (y(), d(s, {
					key: 2,
					class: "property-recursive",
					title: C(G)("schema.recursiveReference", { name: W.recursiveTo })
				}, {
					default: w(() => [h(S(C(G)("schema.recursive")), 1)]),
					_: 1
				}, 8, ["title"])) : f("", !0),
				Z.value ? (y(), d(s, {
					key: 3,
					truncate: ""
				}, {
					prefix: w(() => [h(S(C(G)("schema.keys")) + ":", 1)]),
					default: w(() => [h(" " + S(Z.value), 1)]),
					_: 1
				})) : f("", !0),
				(y(!0), p(l, null, b(ie.value, (e) => (y(), d(s, {
					key: e.key,
					code: e.code,
					truncate: e.truncate
				}, ne({
					default: w(() => [e.key === "format" ? (y(), p("span", I, S(C(G)("schema.format")) + ": ", 1)) : f("", !0), h(" " + S(e.value), 1)]),
					_: 2
				}, [e.prefix ? {
					name: "prefix",
					fn: w(() => [h(S(e.prefix), 1)]),
					key: "0"
				} : void 0]), 1032, ["code", "truncate"]))), 128)),
				W.enum ? (y(), d(s, { key: 4 }, {
					default: w(() => [h(S(C(G)("schema.enum")), 1)]),
					_: 1
				})) : f("", !0)
			], 64)) : f("", !0),
			W.additional ? (y(), p("div", L, [W.value?.["x-additionalPropertiesName"] ? (y(), p(l, { key: 0 }, [h(S(W.value["x-additionalPropertiesName"]), 1)], 64)) : (y(), p(l, { key: 1 }, [h(S(C(G)("schema.additionalProperties")), 1)], 64))])) : f("", !0),
			W.value?.deprecated ? (y(), p("div", R, [g(i, null, {
				default: w(() => [h(S(C(G)("schema.deprecated")), 1)]),
				_: 1
			})])) : f("", !0),
			_.discriminatorValue === void 0 ? f("", !0) : (y(), p("span", z, [h(S(C(G)("schema.discriminatorValue")) + ": ", 1), g(o, { value: _.discriminatorValue }, null, 8, ["value"])])),
			q.value === void 0 ? (y(), p(l, { key: 7 }, [W.value?.nullable === !0 ? (y(), d(s, { key: 0 }, {
				default: w(() => [h(S(C(G)("schema.nullable")), 1)]),
				_: 1
			})) : f("", !0)], 64)) : (y(), p("div", B, [g(s, { truncate: "" }, {
				prefix: w(() => [h(S(C(G)("schema.const")) + ": ", 1)]),
				default: w(() => [g(o, { value: q.value }, null, 8, ["value"])]),
				_: 1
			})])),
			W.value?.writeOnly ? (y(), p("div", V, S(C(G)("schema.writeOnly")), 1)) : W.value?.readOnly ? (y(), p("div", H, S(C(G)("schema.readOnly")), 1)) : f("", !0),
			W.required ? (y(), p("div", U, S(C(G)("schema.required")), 1)) : f("", !0),
			W.value?.default === void 0 ? f("", !0) : (y(), d(ee, {
				key: 11,
				value: W.value?.default
			}, null, 8, ["value"])),
			$.value ? (y(), d(te, {
				key: 12,
				pattern: $.value
			}, null, 8, ["pattern"])) : f("", !0),
			W.withExamples && se.value ? (y(), d(c, {
				key: 13,
				example: Q.value,
				examples: W.value?.examples
			}, null, 8, ["example", "examples"])) : f("", !0),
			x(e.$slots, "preview", {}, void 0, !0),
			x(e.$slots, "trailing", {}, void 0, !0)
		]));
	}
});
//#endregion
export { W as default };

//# sourceMappingURL=SchemaPropertyHeading.vue.script.js.map